import EventEmitter from 'eventemitter3'
import {useEffect} from 'react'

export const globalEvents = new EventEmitter()

export function raise(...params) {
    globalEvents.emit(...params)
}

export function once(...params) {
    globalEvents.once(...params)
}

export function handle(...params) {
    globalEvents.on(...params)
    return () => {
        globalEvents.off(...params)
    }
}

export function useEvent(event, fn) {
    useEffect(() => {
        return handle(event, fn)
    })
}

